import { createFileRoute } from '@tanstack/react-router'
import { ArtifactsPage } from '@/pages/ArtifactsPage'

export const Route = createFileRoute('/_app/artifacts/')({
  component: ArtifactsPage,
})
